























import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { TooltipPlacement } from '@getaccept/lib-shared/src/enums/tooltip-placement';
import { DrView } from '../types';

export default defineComponent({
  name: 'NavigationItem',
  props: {
    active: {
      type: Boolean,
    },
    item: {
      type: Object as PropType<{ label: string; key: DrView; disabled?: boolean }>,
      required: true,
    },
  },
  setup(props) {
    const disabledTooltip = computed(() =>
      props.item.key === DrView.Chat ? t('dsr_navigation_item_disabled_chat_tooltip') : ''
    );

    return {
      TooltipPlacement,
      disabledTooltip,
    };
  },
});
